import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Helper untuk format tanggal dan mata uang
const formatDate = (dateString) => new Date(dateString).toLocaleDateString('id-ID');
const formatCurrency = (number) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(number);

// Komponen Badge untuk Status
const StatusBadge = ({ status }) => {
    const style = {
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '12px',
        color: 'white',
        fontWeight: 'bold',
    };
    let backgroundColor;
    switch (status) {
        case 'Paid':
            backgroundColor = '#28a745'; // Hijau
            break;
        case 'Sent':
            backgroundColor = '#17a2b8'; // Biru
            break;
        case 'Overdue':
            backgroundColor = '#dc3545'; // Merah
            break;
        case 'Draft':
        default:
            backgroundColor = '#6c757d'; // Abu-abu
            break;
    }
    return <span style={{ ...style, backgroundColor }}>{status}</span>;
};


const InvoiceList = () => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchInvoices = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            try {
                const config = { headers: { 'x-auth-token': token } };
                const res = await axios.get('https://planstopia-production.up.railway.app/api/invoices', config);
                setInvoices(res.data);
            } catch (err) {
                setError('Gagal memuat daftar invoice.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchInvoices();
    }, [navigate]);
    
    const handleDelete = async (id) => {
        // Menggunakan konfirmasi bawaan browser untuk kemudahan
        const isConfirmed = window.confirm('Apakah Anda yakin ingin menghapus invoice ini?');
        if (isConfirmed) {
            try {
                const token = localStorage.getItem('token');
                const config = { headers: { 'x-auth-token': token } };
                await axios.delete(`https://planstopia-production.up.railway.app/api/invoices/${id}`, config);
                setInvoices(invoices.filter(invoice => invoice._id !== id));
            } catch (err) {
                 setError('Gagal menghapus invoice.');
                 console.error(err);
            }
        }
    };
    
    if (loading) return <div><h2>Memuat invoice...</h2></div>;
    if (error) return <div><p style={{color: 'red'}}>{error}</p></div>;

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h2>Daftar Semua Invoice</h2>
                <button onClick={() => navigate('/invoices/new')} style={styles.newButton}>Buat Invoice Baru</button>
            </div>
            <div style={styles.tableContainer}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>No. Invoice</th>
                            <th style={styles.th}>Nama Klien</th>
                            <th style={styles.th}>Jatuh Tempo</th>
                            <th style={styles.th}>Total</th>
                            <th style={styles.th}>Status</th>
                            <th style={styles.th}>Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.length > 0 ? invoices.map(invoice => (
                            <tr key={invoice._id}>
                                <td style={styles.td}>{invoice.invoiceNumber}</td>
                                <td style={styles.td}>{invoice.clientName}</td>
                                <td style={styles.td}>{formatDate(invoice.dueDate)}</td>
                                <td style={styles.td}>{formatCurrency(invoice.total)}</td>
                                <td style={styles.td}><StatusBadge status={invoice.status} /></td>
                                <td style={styles.td}>
                                    {/* TOMBOL BARU DITAMBAHKAN DI SINI */}
                                    <button onClick={() => navigate(`/invoices/preview/${invoice._id}`)} style={{...styles.actionBtn, color: '#0d6efd'}}>Pratinjau</button>
                                    <button onClick={() => navigate(`/invoices/edit/${invoice._id}`)} style={styles.actionBtn}>Edit</button>
                                    <button onClick={() => handleDelete(invoice._id)} style={{...styles.actionBtn, ...styles.deleteBtn}}>Hapus</button>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="6" style={{...styles.td, textAlign: 'center'}}>Belum ada invoice.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


const styles = {
    newButton: { padding: '10px 15px', background: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' },
    tableContainer: { background: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', overflow: 'hidden', marginTop: '20px' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { background: '#f1f5f9', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #ddd', fontSize: '14px', fontWeight: 'bold' },
    td: { padding: '12px 16px', borderBottom: '1px solid #e2e8f0', fontSize: '14px' },
    actionBtn: { marginRight: '8px', padding: '6px 10px', border: 'none', background: 'transparent', borderRadius: '4px', cursor: 'pointer', fontWeight: '500' },
    deleteBtn: { color: '#dc3545'},
};

export default InvoiceList;

